import { gql } from "apollo-boost";

export default gql`
  query FFServices($filter: FulfillServiceFilter) {
    FulfillServices(filter: $filter) {
      total
      nodes {
        id
        title:name
        status
        type
        createdAt
        apiKey
        templates {
          id
          name
          data
          createdAt
        }
      }
    }
  }
`;
